import { type FC } from 'react';

import { BaseIcon, type BaseIconOuterProps } from '@/components/common/icons/BaseIcon';

export const AlertCircleIcon: FC<BaseIconOuterProps> = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 12C2.25 6.61704 6.61704 2.25 12 2.25C17.383 2.25 21.75 6.61704 21.75 12C21.75 17.383 17.383 21.75 12 21.75C6.61704 21.75 2.25 17.383 2.25 12ZM12 3.75C7.44546 3.75 3.75 7.44546 3.75 12C3.75 16.5545 7.44546 20.25 12 20.25C16.5545 20.25 20.25 16.5545 20.25 12C20.25 7.44546 16.5545 3.75 12 3.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9901 6.75238C12.1286 6.75106 12.2659 6.77797 12.3936 6.83148C12.5214 6.88502 12.6369 6.96406 12.7331 7.06375C12.8293 7.16346 12.9042 7.28173 12.9531 7.41134C13.0021 7.54095 13.0241 7.67918 13.0178 7.8176L12.7492 13.5352C12.7304 13.9353 12.4005 14.25 12 14.25C11.5995 14.25 11.2697 13.9353 11.2508 13.5353L10.9817 7.8176C10.9755 7.68083 10.9969 7.54422 11.0447 7.41591C11.0924 7.28761 11.1656 7.17024 11.2597 7.07081C11.3538 6.97139 11.467 6.89195 11.5925 6.83724C11.7179 6.78256 11.8531 6.7537 11.9899 6.75238"
      />
      <path d="M12 17.2458C11.8146 17.2458 11.6333 17.1908 11.4792 17.0878C11.325 16.9848 11.2048 16.8384 11.1339 16.667C11.0629 16.4957 11.0443 16.3072 11.0805 16.1254C11.1167 15.9435 11.206 15.7765 11.3371 15.6454C11.4682 15.5143 11.6352 15.425 11.8171 15.3888C11.999 15.3526 12.1875 15.3712 12.3588 15.4421C12.5301 15.5131 12.6765 15.6333 12.7795 15.7874C12.8825 15.9416 12.9375 16.1229 12.9375 16.3083C12.9375 16.5569 12.8387 16.7954 12.6629 16.9712C12.4871 17.147 12.2486 17.2458 12 17.2458Z" />
    </BaseIcon>
  );
};
